export default __webpack_public_path__ + "alberta-sort-timestamp-old.c222876191861d8ddadc.svg";